<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <h5>Mesaje</h5>
        </div>
        <div class="card-body tab2-card">
          <ngb-tabset class="tab-coupon">
            <ngb-tab title="Mesaje Contract">
              <ng-template ngbTabContent>
                <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
                  <form [formGroup]="contractMessageForm" class="needs-validation" novalidate>
                    <div class="form-group row">
                      <div class="col-xl-3 col-md-3">
                        <label>Autor UUID</label>
                        <input class="form-control" type="text" formControlName="authorId">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Message ID</label>
                        <input class="form-control" type="text" formControlName="messageId">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Correlation ID</label>
                        <input class="form-control" type="text" formControlName="correlationId">
                      </div>
                      <a href="javascript:void(0);" (click)="showMoreFilters()">
                        <img *ngIf="!isFilterExpanded" src="../../../../assets/images/arrow-down.png" width="32">
                        <img *ngIf="isFilterExpanded" src="../../../../assets/images/arrow-up.png" width="32">
                      </a>
                      <div class="col-xl-auto col-md-auto" style="margin-top: auto">
                        <button type="button" class="btn btn-primary" (click)="searchContractMessages()">
                          Cauta
                        </button>
                      </div>
                    </div>
                    <ng-container *ngIf="isFilterExpanded">
                      <div class="form-group row">
                        <div class="col-xl-3 col-md-3">
                          <label>Tip</label>
                          <select class="form-control" type="text" formControlName="type">
                            <option value="ContractSignedBySupplier">ContractSignedBySupplier</option>
                            <option value="ContractChangedInfo">ContractChangedInfo</option>
                          </select>
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>Numar Contract</label>
                          <input class="form-control" type="text" formControlName="number">
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>Furnizor UUID</label>
                          <input class="form-control" type="text" formControlName="supplierUUID">
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-xl-3 col-md-3">
                          <label>POD/CLC</label>
                          <input class="form-control" type="text" formControlName="placeCode">
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>Operator UUID</label>
                          <input class="form-control" type="text" formControlName="operatorUUID">
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>CNP</label>
                          <input class="form-control" type="text" formControlName="clientCodeP">
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-xl-3 col-md-3">
                          <label>CUI</label>
                          <input class="form-control" type="text" formControlName="clientCodeC">
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>Init</label>
                          <select class="form-control" type="text" formControlName="isInit">
                            <option value="true">DA</option>
                            <option value="false">NU</option>
                          </select>
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label>POSF</label>
                          <select class="form-control" type="text" formControlName="isFromPosf">
                            <option value="true">DA</option>
                            <option value="false">NU</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-xl-3 col-md-3">
                          <label>Success</label>
                          <select class="form-control" type="text" formControlName="isSuccess">
                            <option value="true">DA</option>
                            <option value="false">NU</option>
                          </select>
                        </div>
                      </div>
                    </ng-container>
                    <hr>
                    <form [formGroup]="sortMessageForm" class="needs-validation" novalidate>
                      <div class="form-group row">
                        <div class="col-xl-3 col-md-3">
                          <label>Sorteaza dupa:</label>
                          <select class="form-control" type="text" formControlName="sortBy"
                            (change)="onChangeSortCriteria()">
                            <option value="timestamp">Timestamp</option>
                          </select>
                        </div>
                        <div class="col-xl-3 col-md-3">
                          <label></label>
                          <select class="form-control" type="text" formControlName="sortDirection">
                            <option value="ASC">Crescator</option>
                            <option value="DESC">Descrescator</option>
                          </select>
                        </div>
                        <div class="col-xl-auto col-md-auto" style="margin-top: auto">
                          <button type="button" class="btn btn-primary" (click)="searchContractMessages()">
                            Sorteaza
                          </button>
                        </div>
                      </div>
                    </form>
                  </form>
                  <br>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="contractMessageSettings" [source]="contractMessages?.content"
                        (custom)="onCustomActionContractMessage($event)"></ng2-smart-table>
                    </div>
                  </div>
                  <div *ngIf="contractMessages?.totalElements">
                    <h4 class="pagination justify-content-center">
                      Total Mesaje: {{contractMessages?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousContractMessagesPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationContractMessages" [ngClass]="page.className"
                        (click)="changeContractMessagesPage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextContractMessagesPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>
            <!--<ngb-tab>
              <ng-template ngbTabTitle>Mesaje Broker
                <ng-template ngbTabContent>
                  <form [formGroup]="brokerMessageForm" class="needs-validation" novalidate>
                    <div class="form-group row pb-3">
                      <div class="col-xl-3 col-md-3">
                        <label>Message ID</label>
                        <input class="form-control" type="text" formControlName="messageId">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Correlation ID</label>
                        <input class="form-control" type="text" formControlName="correlationId">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Tip</label>
                        <input class="form-control" type="text" formControlName="type">
                      </div>
                      <div class="col-xl-1 col-md-1" style="margin-top: auto">
                        <button type="button" class="btn btn-primary" (click)="searchBrokerMessages()">
                          Cauta
                        </button>
                      </div>
                    </div>
                  </form>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="brokerMessageSettings"
                                       [source]="brokerMessages?.content"
                                       (custom)="onCustomActionBrokerMessage($event)">
                      </ng2-smart-table>
                    </div>
                  </div>
                  <div *ngIf="brokerMessages?.totalElements">
                    <h4 class="pagination justify-content-center">
                      Total Mesaje: {{brokerMessages?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousBrokerMessagePage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationBrokerMessages" [ngClass]="page.className"
                          (click)="changeBrokerMessagePage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextBrokerMessagePage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </ng-template>
            </ngb-tab>-->
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->